import { MARK_POSITIVE, MARK_REVERSED, TILE_RADIUS, TILE_TRANSFORM } from "./mark";
import "./brand.css";

type Props = {
  /** "tile" = ícono de app (cuadrado negro); "mark" = isotipo suelto en currentColor. */
  variant?: "mark" | "tile";
  size?: number;
  /** Con título se anuncia como imagen; sin él es decorativo. */
  title?: string;
  className?: string;
};

/** Isotipo de Mixcore en SVG. */
export function MixcoreMark({ variant = "mark", size = 24, title, className }: Props) {
  const isTile = variant === "tile";
  const mark = isTile ? MARK_REVERSED : MARK_POSITIVE;
  const a11y = title ? { role: "img", "aria-label": title } : { "aria-hidden": true };

  return (
    <svg
      className={["mx-mark", `mx-mark--${variant}`, className].filter(Boolean).join(" ")}
      viewBox="0 0 100 100"
      width={size}
      height={size}
      focusable="false"
      {...a11y}
    >
      {isTile && <rect className="mx-mark__tile" width="100" height="100" rx={TILE_RADIUS} />}
      <g transform={isTile ? TILE_TRANSFORM : undefined}>
        <path className="mx-mark__ring" d={mark.d} />
        <circle className="mx-mark__dot" cx="50" cy="50" r={mark.dotR} />
      </g>
    </svg>
  );
}
